var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5175 15.207L8.14692 12.0568C8.32407 11.705 8.59352 11.408 8.92645 11.1975C9.25939 10.987 9.64328 10.871 10.0371 10.8619H21.7255M21.7255 10.8619C22.0574 10.8613 22.385 10.9368 22.6832 11.0825C22.9814 11.2282 23.2422 11.4403 23.4457 11.7025C23.6492 11.9647 23.7898 12.2701 23.857 12.5951C23.9241 12.9202 23.9158 13.2563 23.8329 13.5776L22.16 20.0953C22.0389 20.5641 21.7648 20.979 21.381 21.2742C20.9973 21.5694 20.5259 21.728 20.0417 21.7247H4.34493C3.76873 21.7247 3.21613 21.4958 2.80869 21.0884C2.40126 20.681 2.17236 20.1284 2.17236 19.5522V5.43048C2.17236 4.85428 2.40126 4.30168 2.80869 3.89425C3.21613 3.48681 3.76873 3.25792 4.34493 3.25792H8.58144C8.94478 3.25435 9.30322 3.34198 9.62394 3.51278C9.94466 3.68358 10.2174 3.93209 10.4173 4.23557L11.2971 5.53911C11.495 5.8395 11.7643 6.08608 12.0809 6.25671C12.3975 6.42735 12.7516 6.51671 13.1112 6.51677H19.5529C20.1291 6.51677 20.6817 6.74566 21.0891 7.1531C21.4966 7.56053 21.7255 8.11313 21.7255 8.68933V10.8619Z",
    stroke: "#919090",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.80eff6d44e9b41c48cd5eb514668c61a.svg";
export { ForwardRef as ReactComponent };